export default __webpack_public_path__ + "static/media/mcp.e86477fe.jpg";